(function ($) {
  'use strict';

  const MODAL_ID = 'l7l-video-modal';

  // Inject modal once
  if (!$('#' + MODAL_ID).length) {
    $('body').append(`
      <div id="${MODAL_ID}" role="dialog" aria-modal="true" aria-label="Video" style="
          display:none;
          position:fixed;
          inset:0;
          z-index:99999;
          background:rgba(0,0,0,.82);
          align-items:center;
          justify-content:center;
      ">

        <!-- Close button -->
        <button id="${MODAL_ID}-close" aria-label="Close video" style="
            position:absolute;
            top:16px;
            right:20px;
            background:transparent;
            border:none;
            cursor:pointer;
            color:#fff;
            font-size:32px;
            line-height:1;
        ">
          &#x2715;
        </button>

        <!-- Video wrapper -->
        <div style="
          width:min(880px,92vw);
          position:relative;
        ">
          <div style="
            position:relative;
            width:100%;
            aspect-ratio:16/9;
          ">
            <iframe
              id="l7l-video-iframe"
              src=""
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
              style="
                position:absolute;
                inset:0;
                width:100%;
                height:100%;
                border:0;
              ">
            </iframe>
          </div>
        </div>

      </div>
    `);
  }

  const $modal = $('#' + MODAL_ID);
  const $iframe = $('#l7l-video-iframe');

  function getEmbedUrl(url) {
    let embedUrl = '';
    let videoId = '';

    // YouTube Shorts
    const shortsMatch = url.match(
      /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/
    );

    // Standard YouTube
    const ytMatch = url.match(
      /(?:youtu\.be\/|[?&]v=)([a-zA-Z0-9_-]{11})/
    );

    // Vimeo
    const vimeoMatch = url.match(
      /vimeo\.com\/([0-9]+)/
    );

    if (shortsMatch) {
      videoId = shortsMatch[1];

      embedUrl =
        'https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1&rel=0';

    } else if (ytMatch) {
      videoId = ytMatch[1];

      embedUrl =
        'https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1&rel=0';

    } else if (vimeoMatch) {
      videoId = vimeoMatch[1];

      embedUrl =
        'https://player.vimeo.com/video/' +
        videoId +
        '?autoplay=1';
    }

    return embedUrl;
  }

  function openModal(videoUrl) {
    const embedUrl = getEmbedUrl(videoUrl);

    if (!embedUrl) return;

    $iframe.attr('src', embedUrl);

    $modal.css('display', 'flex');
    $('body').css('overflow', 'hidden');
  }

  function closeModal() {
    $iframe.attr('src', '');

    $modal.hide();
    $('body').css('overflow', '');
  }

  // Open popup on card click
  $(document).on('click', '.L7L-reviews .card', function () {
    const videoUrl = $(this)
      .find('.video-embed-wrapper')
      .data('url');

    openModal(videoUrl);
  });

  // Close button
  $(document).on('click', '#' + MODAL_ID + '-close', function () {
    closeModal();
  });

  // Click outside video
  $(document).on('click', '#' + MODAL_ID, function (e) {
    if ($(e.target).is('#' + MODAL_ID)) {
      closeModal();
    }
  });

  // Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $modal.is(':visible')) {
      closeModal();
    }
  });

})(jQuery);